import { render, staticRenderFns } from "./MaterialRoomList.vue?vue&type=template&id=20fc854c&scoped=true&lang=pug&"
import script from "./MaterialRoomList.vue?vue&type=script&lang=js&"
export * from "./MaterialRoomList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRoomList.vue?vue&type=style&index=0&id=20fc854c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc854c",
  null
  
)

export default component.exports